// Locally, we do not check this file as the local Typescript server in editors cannot handle the large JSON files.
// On CI, we will remove this full comment block and will still typecheck this file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import {
  LanguageKey,
  TranslatedMessages,
} from '@transcend-io/internationalization';

/**
 * Translations of intl messages
 */
export const PRIVACY_CENTER_TRANSLATIONS: {
  [k in LanguageKey]: () => Promise<{
    /** Default */
    default: TranslatedMessages;
  }>;
} = {
  [LanguageKey.En]: () => import('./en.json'),
  [LanguageKey.Ar]: () => import('./ar.json'),
  [LanguageKey.Fr]: () => import('./fr.json'),
  [LanguageKey.De]: () => import('./de.json'),
  [LanguageKey.It]: () => import('./it.json'),
  [LanguageKey.Ja]: () => import('./ja.json'),
  [LanguageKey.Es]: () => import('./es.json'),
  [LanguageKey.Ru]: () => import('./ru.json'),

  [LanguageKey.ArAe]: () => import('./ar-AE.json'),
  [LanguageKey.FrFr]: () => import('./fr-FR.json'),
  [LanguageKey.DeDe]: () => import('./de-DE.json'),
  [LanguageKey.ItIt]: () => import('./it-IT.json'),
  [LanguageKey.AfZz]: () => import('./af-ZA.json'),
  [LanguageKey.BgBg]: () => import('./bg-BG.json'),
  [LanguageKey.ZhCn]: () => import('./zh-CN.json'),
  [LanguageKey.HrHr]: () => import('./hr-HR.json'),
  [LanguageKey.CsCz]: () => import('./cs-CZ.json'),
  [LanguageKey.DaDk]: () => import('./da-DK.json'),
  [LanguageKey.EnGb]: () => import('./en-GB.json'),
  [LanguageKey.EnCa]: () => import('./en-CA.json'),
  [LanguageKey.EnAe]: () => import('./en-AE.json'),
  [LanguageKey.FiFi]: () => import('./fi-FI.json'),
  [LanguageKey.ElGr]: () => import('./el-GR.json'),
  [LanguageKey.HiIn]: () => import('./hi-IN.json'),
  [LanguageKey.HuHu]: () => import('./hu-HU.json'),
  [LanguageKey.IdId]: () => import('./id-ID.json'),
  [LanguageKey.JaJp]: () => import('./ja-JP.json'),
  [LanguageKey.KoKr]: () => import('./ko-KR.json'),
  [LanguageKey.LtLt]: () => import('./lt-LT.json'),
  [LanguageKey.MsMy]: () => import('./ms-MY.json'),
  [LanguageKey.MrIn]: () => import('./mr-IN.json'),
  [LanguageKey.NbNi]: () => import('./nb-NO.json'),
  [LanguageKey.PlPl]: () => import('./pl-PL.json'),
  [LanguageKey.PtBr]: () => import('./pt-BR.json'),
  [LanguageKey.PtPt]: () => import('./pt-PT.json'),
  [LanguageKey.RoRo]: () => import('./ro-RO.json'),
  [LanguageKey.RuRu]: () => import('./ru-RU.json'),
  [LanguageKey.SrLatnRs]: () => import('./sr-Latn-RS.json'),
  [LanguageKey.SvSe]: () => import('./sv-SE.json'),
  [LanguageKey.TaIn]: () => import('./ta-IN.json'),
  [LanguageKey.ThTh]: () => import('./th-TH.json'),
  [LanguageKey.TrTr]: () => import('./tr-TR.json'),
  [LanguageKey.UkUa]: () => import('./uk-UA.json'),
  [LanguageKey.ViVn]: () => import('./vi-VN.json'),
  [LanguageKey.ZuZa]: () => import('./zu-ZA.json'),
  [LanguageKey.EnUS]: () => import('./en-US.json'),
  [LanguageKey.EnAu]: () => import('./en-AU.json'),
  [LanguageKey.FrBe]: () => import('./fr-BE.json'),
  [LanguageKey.FrCa]: () => import('./fr-CA.json'),
  [LanguageKey.EnIe]: () => import('./en-IE.json'),
  [LanguageKey.NlNl]: () => import('./nl-NL.json'),
  [LanguageKey.NlBe]: () => import('./nl-BE.json'),
  [LanguageKey.EsEs]: () => import('./es-ES.json'),
  [LanguageKey.Es419]: () => import('./es-419.json'),
  [LanguageKey.ZhHk]: () => import('./zh-HK.json'),
  [LanguageKey.DeAt]: () => import('./de-AT.json'),
  [LanguageKey.DeCh]: () => import('./de-CH.json'),
  [LanguageKey.ItCh]: () => import('./it-CH.json'),
  [LanguageKey.FrCh]: () => import('./fr-CH.json'),
  [LanguageKey.HeIl]: () => import('./he-IL.json'),
  [LanguageKey.EnNz]: () => import('./en-NZ.json'),
  [LanguageKey.EtEe]: () => import('./et-EE.json'),
  [LanguageKey.IsIs]: () => import('./is-IS.json'),
  [LanguageKey.LvLv]: () => import('./lv-LV.json'),
  [LanguageKey.MtMt]: () => import('./mt-MT.json'),
  [LanguageKey.SkSk]: () => import('./sk-SK.json'),
  [LanguageKey.SlSl]: () => import('./sl-SL.json'),
};
